import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import * as moment from 'moment';
import { DataServiceService } from '../../../services/student-services/common/data-service.service';
import { SidebarService } from '../../../services/student-services/common/sidebar.service';
import { CommonService } from '../../../services/student-services/common/common.service';
import { PersistentStorageService } from '../../../services/common/persistent-storage.service';
import { USER_KEY } from '../../../constants/user-constants';
import { EVENT, LOGTYPE } from '../../../constants/logging';

@Component({
	selector: 'app-checklist',
	templateUrl: './checklist.component.html',
	styleUrls: [ './checklist.component.scss' ]
})
export class ChecklistComponent implements OnInit, OnChanges {
	@Output() activePhaseAndTaskEvent = new EventEmitter<any>();
	@Output() updateHUD = new EventEmitter<any>();

	@Input() taskInput;
	@Input() currentUser;
	@Input() studentData;
	@Input() sidebarInput;
	@Input() tasks;

	@Input() viewOnlyFlag;
	viewDetailsModal;
	lastElement;
	isShow = false;

	checkActivity = [];
	public arr = [];
	public currentStaff = this.persistentStorageService.getLocalStorage(USER_KEY.CURRENT_STAFF_EMAIL);

	constructor(
		private readonly dataService: DataServiceService,
		private readonly common: CommonService,
		private readonly sidebarService: SidebarService,
		private readonly persistentStorageService: PersistentStorageService
	) {}
	public showListMessage = true;
	public updateFlag = false;
	public lastCompletedSubtaskId;
	public subtaskIds;
	public unchecked;
	public len = 0;
	public viewDetailButton;
	public viewCheckID;
	public disableViewButton = false;
	public lastGoaldate;
	public goalDateMessage;
	sideBarData: boolean;
	isUnlockedTask = false;

	ngOnInit() {
		this.sidebarService.isSidebarActive.subscribe((isSidebarData: boolean) => {
			this.sideBarData = isSidebarData;
		});
	}

	ngOnChanges(changes: SimpleChanges) {
		if (
			changes &&
			changes.taskInput &&
			changes.taskInput.currentValue &&
			changes.taskInput.currentValue.subtasks &&
			changes.taskInput.currentValue.subtasks.length > 0
		) {
			changes.taskInput.currentValue.subtasks.forEach((task, index) => {
				Object.assign(task, { itemChecked: false, subtaskId: index });
			});
		}
	}

	public viewDetails(subtask) {
		this.viewDetailButton = false;
		this.viewDetailsModal = subtask;
		this.viewDetailsModal.publishedResources = this.publishedResources(subtask);
		this.viewDetailsModal.publishedHelpItems = this.publishedHelpItems(subtask);
		this.viewDetailsModal.publishedHelpItems.forEach((helpItem, index) => {
			this.viewDetailsModal.publishedHelpItems[index].isChair = this.isChair(helpItem);
			this.viewDetailsModal.publishedHelpItems[index].chairDataFor = this.chairDataFor(helpItem);
			this.viewDetailsModal.publishedHelpItems[index].mailtoFor = this.mailtoFor(helpItem);
		});
		if (this.viewDetailsModal.is_complete) {
			this.viewDetailButton = true;
		}
	}

	private publishedResources(subtask) {
		if (subtask && subtask.resource_links) {
			return subtask.resource_links.filter((resource, index, arr) => {
				return resource.published !== false;
			});
		}
		return [];
	}

	private publishedHelpItems(subtask) {
		if (subtask && subtask.help_items) {
			return subtask.help_items.filter((helpItem, index, arr) => {
				return helpItem.published !== false;
			});
		}
		return [];
	}
	private isChair(helpItem) {
		return helpItem.identifier === 'your_chair';
	}
	private chairDataFor(helpItem) {
		return undefined;
	}
	private mailtoFor(helpItem) {
		if (helpItem.email) {
			return `mailto:${helpItem.email}`;
		} else {
			return '';
		}
	}

	public viewDetailsFunc(event, subtask) {
		this.handleSubtask(event, subtask._id);
	}

	public closeModal() {
		this.viewDetailsModal = '';
	}
	public keepGoing() {
		this.updateFlag = true;
		this.isShow = false;
		const currentPhaseTask = this.calculateNextPahseAndTask(
			this.sidebarInput.phases,
			this.taskInput,
			this.studentData
		);
		this.activePhaseAndTaskEvent.emit(currentPhaseTask);
		this.updateToFirestore(this.subtaskIds, this.taskInput, currentPhaseTask);
	}
	public closeMarkmodal() {
		this.updateFlag = false;
		this.isShow = false;
		if (this.lastCompletedSubtaskId) {
			document.querySelector(this.lastCompletedSubtaskId).checked = false;
		}
	}

	/**
   * @description Will calculate the next pending phase and task for redirecting the user.
   * @param phases (array) Will hold all phases wth task property
   * @param currentTask (Object) will hold the current active task information.
   * @param studentData (Object) will hold student doc data
   */
	public calculateNextPahseAndTask(phases, currentTask, studentData) {
		let nextPhase; // will hold next phase information
		let nextTask; // Will hold next task information

		// loop through the all phases and check for
		// pending task and then get the pahse information as well.

		let phaseIndex = 0;
		while (phaseIndex < phases.length) {
			// each phase
			// tslint:disable-next-line: prefer-for-of
			for (let taskIndex = 0; taskIndex < phases[phaseIndex].tasks.length; taskIndex++) {
				// each task
				const phaseObject = { ...phases[phaseIndex] };
				const taskObject = { ...phases[phaseIndex].tasks[taskIndex] };
				if (taskObject._id !== currentTask._id) {
					// get lock status info
					const lockedStatus = this.checkTaskStatus(taskObject, studentData);
					if (!lockedStatus) {
						// If not locked then this is the pending task.
						nextPhase = phaseObject;
						nextTask = taskObject;
						break; // braek for..loop
					} // End of if
				} // End of if
			} // End of for
			if (nextPhase && nextTask) {
				break; // braek while loop
			}
			phaseIndex++;
		} // End of while loop
		if (!nextPhase && !nextTask) {
			nextPhase = phases[0];
			nextTask = phases[0].tasks[0];
		}
		return {
			nextPhase,
			nextTask
		};
	}

	/**
   * @description This function will check that the task status is locked or not
   * @param task (Object) Task Object
   * @param studentData (Object) Student doc data
   */
	public checkTaskStatus(task, studentData) {
		if (studentData.user_tasks) {
			const lockedTaskInfo = studentData.user_tasks.find((lockedTask) => {
				if (lockedTask.task_id === task._id) {
					return lockedTask;
				}
			});
			if (lockedTaskInfo) {
				return true;
			}
			return false;
		} else {
			return false;
		}
	}

	/**
   * @description This function will handle single todo update resquest
   * @param event (onChangeEvent)
   * @param subtaskId (string) this is subtask which we need to update into firestotre
   */

	public handleSubtask(event, subtaskId, subtask?) {
		if (subtask) {
			subtask.itemChecked = subtask.is_completed ? true : false;
		}

		// this array will hold all the subtask id which needs to be update
		const subtaskArray = [];
		const elementId: string = (event.target as Element).id;
		let isCompleteCount = 0;
		// this obj will hold the todo checked status, to pass the event information
		const obj = {
			subtaskId,
			checked: false
		};

		obj.subtaskId = subtaskId;
		if (event.target.checked) {
			obj.checked = true;
		}
		// Storing subtask information
		subtaskArray.push(obj);
		// Assigning this to golbal elevel
		this.subtaskIds = subtaskArray;
		/**
     * Based on that update flag we will update the data default is false
     * When single todo update request comes in then flag value will be true
     * When pop will close then update flag will be true
     */

		this.updateFlag = false;

		/**
     * This is to check when we need to show the popup.
     */
		this.taskInput.subtasks.forEach((element) => {
			if (element.is_complete) {
				// if complete then increate complete count
				isCompleteCount += 1;
			}
		});
		// setu flag for both popu and update
		if (this.taskInput.subtasks.length === isCompleteCount + 1 && event.target.checked) {
			// to unchecked the last todo for songle todo operation
			this.lastCompletedSubtaskId = '#' + elementId;
			this.isShow = true;
		} else {
			this.updateFlag = true;
		}
		if (this.updateFlag) {
			// update the db
			this.updateToFirestore(subtaskArray, null, null);
		}
	} // End of updateSubtask

	/**
   * This function is for update the DB
   * @param subtaskArray (Array) all todos information for db updation
   */
	async updateToFirestore(subtaskArray, currentTask, currentPhaseTask) {
		this.dataService.getStudentDataByDocToPromise(this.currentUser.email).then(async (docRef) => {
			const studentDetils = docRef.data();
			// find each subtask and prapre the student user_subtasks array to update
			subtaskArray.forEach((element) => {
				let itemIndex;
				const subtaskObj = studentDetils.user_subtasks.find((item, index) => {
					if (item.subtask_id === element.subtaskId) {
						itemIndex = index;
						return item;
					}
				}); // end of find
				if (!subtaskObj.activity) {
					subtaskObj.activity = [];
				}
				if (element.checked) {
					// Set true
					subtaskObj.is_complete = true;
					subtaskObj.activity.push({ created_at: moment().format(), status: 'completed' });
				} else {
					// set false
					subtaskObj.is_complete = false;
					subtaskObj.activity.push({ created_at: moment().format(), status: 'incompleted' });
				}
				// update the user_subtasks by array index
				studentDetils.user_subtasks[itemIndex] = subtaskObj;
			});
			// End of foreach

			if (this.updateFlag) {
				// tslint:disable-next-line: max-line-length
				await this.dataService
					.updateStudentSubtask(
						this.currentUser.email,
						studentDetils.user_subtasks,
						currentTask,
						currentPhaseTask
					)
					.then(() => {
						this.updateFlag = false;
					});
				this.updateHUD.emit(this.studentData);
			}
		}); // End of getStudentDataByDocToPromise service
	}

	/**
   * Functionality for mark all as complete button
   */
	public markComplete() {
		this.len = 0;
		const unchecked = [];
		this.lastElement = true;
		this.taskInput.subtasks.forEach((subtask) => {
			if (subtask.is_complete === false) {
				const obj = {
					subtaskId: subtask._id,
					checked: true
				};
				unchecked.push(obj);
			}
		});
		this.subtaskIds = unchecked;
		this.taskInput.isLastTask = this.common.isLastTask(this.studentData, this.tasks);
		this.isShow = true;
	}

	public unLockTask() {
		this.isUnlockedTask = !this.isUnlockedTask;
	}
	public closeUnlockmodal() {
		this.isUnlockedTask = false;
	}
	public unlockModal() {
		this.isUnlockedTask = false;

		const updatedUserTasks = this.studentData.user_tasks.filter((lockedTaskObj: object) => {
			// tslint:disable-next-line: no-string-literal
			if (lockedTaskObj['task_id'] !== this.taskInput._id) {
				return lockedTaskObj;
			}
		});
		try {
			const taskGoalMessage = this.common.displayTaskCompleteionInformation(
				this.taskInput,
				false,
				this.studentData
			);
			this.taskInput.isTaskLocked = false;
			this.taskInput.taskGoalMessage = taskGoalMessage;
			// tslint:disable-next-line: max-line-length
			const description = `Task: [${this.taskInput.name}] of the student [${this.currentUser
				.email}] is unlocked by [${this.currentStaff}].`;
			this.common.addtoStack(this.currentStaff, EVENT.UNLOCK_BY_STAFF, LOGTYPE.INFO, description);

			const currentPhaseTask = this.common.calculateNextPahseAndTask(
				this.sidebarInput.phases,
				this.taskInput,
				this.studentData,
				true
			);
			// tslint:disable-next-line: max-line-length
			this.dataService.updateStudentUserTasksAndCurrentPhaseTask(
				this.studentData.upn,
				updatedUserTasks,
				currentPhaseTask,
				this.studentData.isGraduated
			);
		} catch (e) {
			console.error('Error while updating user tasks -> ', e);
		}
	}
}
